const ROUND = 'stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"';

export const VEILLEUR_MARK =
  `<path d="M9.2 7.4V6a2.8 2.8 0 0 1 5.6 0v1.4" fill="none" ${ROUND} stroke-width="1.8"/>` +
  `<rect x="6.6" y="7.4" width="10.8" height="12.6" rx="2.6" fill="none" ${ROUND} stroke-width="2"/>` +
  '<circle cx="12" cy="13.7" r="2.4" fill="currentColor"/>' +
  '<circle cx="20.6" cy="5.4" r="1.4" fill="currentColor"/>' +
  '<circle cx="3.4" cy="9.6" r="1.1" fill="currentColor"/>';

export const LANTERNE_ICON =
  `<path d="M4.8 9.6 9.6 6.2" fill="none" ${ROUND} stroke-width="2"/>` +
  `<rect x="3.4" y="11" width="9.2" height="10" rx="2.4" fill="none" ${ROUND} stroke-width="2.2"/>` +
  '<circle cx="8" cy="16" r="2" fill="currentColor"/>' +
  `<path d="M12 8.2l1-2M14.8 9l1.6-1.6M15.4 12.6l2.2-.8" fill="none" ${ROUND} stroke-width="1.6"/>` +
  '<circle cx="14" cy="3.6" r="2" fill="currentColor"/>' +
  '<circle cx="18.6" cy="6" r="2" fill="currentColor"/>' +
  '<circle cx="20.4" cy="11" r="2" fill="currentColor"/>';
